import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { VueQueryPlugin } from '@tanstack/vue-query';
import Toast from 'vue-toastification';
import App from './App.vue';
import router from './router';
import { toastConfig } from './services/toast';
import './styles/main.css';
import './styles/font-override.css';
import './styles/design-system.css';
import './assets/toast.css';

const app = createApp(App);

app.use(createPinia());
app.use(router);
app.use(Toast, toastConfig);
app.use(VueQueryPlugin, {
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      gcTime: 1000 * 60 * 10, // 10 minutes
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

app.mount('#app');